import { CdekSuggest } from '@shared/api/getCdekLocationSuggest/types';
import FetchData from '@shared/utils/fetchData/fetchData';

export const getCdekLocationSuggest = async (name: string) => {
  const res = await FetchData.get<{ suggestions: CdekSuggest[] }>(`v2/delivery/location/suggest?name=${name}`, {});

  return res.data?.suggestions ?? [];
};
